import { Component, inject, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ActionConfirmDirective } from '@app/+authenticated/shared/directives/action-confirm.directive';
import { LocaleDatePipe } from '@app/pipes/locale-date.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { mgcIconDelete2Regular } from '@sb/mgc-icons/mgcIcon-delete_2_regular.icon';
import { mgcIconFileRegular } from '@sb/mgc-icons/mgcIcon-file_regular.icon';
import { mgcIconPencilRegular } from '@sb/mgc-icons/mgcIcon-pencil_regular.icon';
import { SectionToolbarComponent } from '@sb/shared/layout/primitives';
import { TooltipDirective } from '@sb/tooltip';
import { AnchorButtonComponent, IconButtonComponent } from '@sb/ui/button';
import { CardComponent } from '@sb/ui/card';
import { EmptyStateComponent, LoadingStateComponent } from '@sb/ui/feedback';
import { IconComponent, IconRegistry } from '@sb/ui/icon';
import {
  TableCellPrimitiveDirective,
  TableContainerDirective,
  TableDirective,
  TableHeaderCellDirective,
  TableRowDirective,
} from '@sb/ui/table';

import { UserNote } from '../../../../reducers/orm/employee/employee.model';
import { EmployeeService } from '../../../../reducers/orm/employee/employee.service';

export interface EmployeeNotePermissions {
  canView: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

@Component({
  selector: 'employee-notes',
  templateUrl: './employee-notes.component.html',
  imports: [
    RouterLink,
    TranslatePipe,
    LocaleDatePipe,
    AnchorButtonComponent,
    IconButtonComponent,
    IconComponent,
    CardComponent,
    EmptyStateComponent,
    LoadingStateComponent,
    TooltipDirective,
    ActionConfirmDirective,
    SectionToolbarComponent,
    TableContainerDirective,
    TableDirective,
    TableRowDirective,
    TableCellPrimitiveDirective,
    TableHeaderCellDirective,
  ],
})
export class EmployeeNotesComponent {
  private employeeService = inject(EmployeeService);

  @Input()
  employeeId: string;
  @Input()
  notes: UserNote[];
  @Input()
  loading = false;
  @Input()
  permissions: EmployeeNotePermissions;

  constructor() {
    inject(IconRegistry).registerIcons([mgcIconFileRegular, mgcIconPencilRegular, mgcIconDelete2Regular]);
  }

  deleteNote(note: UserNote) {
    this.employeeService.deleteNote(this.employeeId, note.id).subscribe();
  }
}
